module.exports = __webpack_public_path__ + "static/step-2.f1b5e2d5.png";